import moment from 'moment';

const toMoment = value => value ? moment(value) : undefined;

const strategy = {
    // 作为antd表单组件使用
    toArray: value => value ? value.split(',') : [],
    toString: value => value || value === 0 ? String(value) : undefined,
    toMoment: value => {
        if (value && Array.isArray(value)) {
            return value.map(i => toMoment(i));
        } else {
            return toMoment(value);
        }
    },
    date: function(value) {
        return value ? `${value}`.slice(0, 10) : '';
    },
    month: function(...rest) {
        const len = rest.length;
        if (len === 2) {
            const [year, month] = rest;
            return `${year}-${month < 10 ? `0${month}` : month}`;
        } else if (len === 1) {
            const [value] = rest;
            return value ? `${value}`.slice(0, 7) : '';
        } else {
            return '';
        }
    },
    year: function(value) {
        return value ? `${value}`.slice(0, 4) : '';
    },
    defaultValue: function(value, defaultValue = '') {
        return (value || value === 0) ? value : defaultValue;
    },
    unit: function(value, unit) {
        return (value || value === 0) ? `${value}${unit}` : '';
    },
    // 两个字段拼接
    joint: function(first, second, connector) {
        switch(connector) {
            case 'kebabCase':
                return first ? `${first}${second ? `-${second}` : ''}` : '';
            case 'roundBrackets':
                return first ? `${first}${second ? `(${second})` : ''}` : '';
            case 'squareBrackets':
            default:
                return first ? `${first}${second ? `[${second}]` : ''}` : '';
        }
    },
    // 千分制
    money: function(contract, exchangeRate) {
        const pattern = /\B(?=(\d{3})+(?!\d))/g;
        if (exchangeRate) {
            return (contract || contract === 0) ? `${(contract * exchangeRate).toFixed(2)}`.replace(pattern, ',') : '';
        } else {
            return (contract || contract === 0) ? `${contract}`.replace(pattern, ',') : '';
        }
    },
    // 人民币小写转大写
    smalltoBIG: function(n) {
        var fraction = ['角', '分'];
        var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
        var unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
        var head = n < 0 ? '欠' : '';
        n = Math.abs(n);
      
        var s = '';
      
        var idx = String(n).indexOf('.');
        var frac = idx >= 0 ? String(n).slice(idx + 1) : '';
        if (frac !== '') {
            for (var i = 0; i < frac.length; i++) {
                s += (digit[frac[i]] + fraction[i]).replace(/零./, '');
            }
        }
        s = s || '整';
        n = Math.floor(n);
      
        for (var i = 0; i < unit[0].length && n > 0; i++) {
            var p = '';
            for (var j = 0; j < unit[1].length && n > 0; j++) {
                p = digit[n % 10] + unit[1][j] + p;
                n = Math.floor(n / 10);
            }
            s = p.replace(/(零.)*零$/, '').replace(/^$/, '零')  + unit[0][i] + s;
        }
        return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
    }
};

export default function(...rest) {
    const [type, ...param] = rest;
    return strategy[type] && strategy[type](...param);
}


// WEBPACK FOOTER //
// ./src/components/shared/format.js